import type { User } from '@/types'
import { normalizeRole } from '@/config/routeAccess'

/** BDR/Closer com modo evento ativo — sem navegação em empresas/contatos. */
export function isEventModeRestrictedUser(
  user: Pick<User, 'role' | 'eventModeActive'> | null | undefined,
): boolean {
  if (!user?.eventModeActive) return false
  const role = normalizeRole(user.role)
  if (role === 'admin') return false
  return role === 'bdr' || role === 'closer'
}

export function canAccessEmpresasContatos(
  user: Pick<User, 'role' | 'eventModeActive'> | null | undefined,
): boolean {
  return !isEventModeRestrictedUser(user)
}

export function canEnableEventModeForRole(role: string): boolean {
  const normalized = normalizeRole(role)
  return normalized === 'bdr' || normalized === 'closer'
}
